import { render } from "./tos.vue?vue&type=template&id=3c794441&scoped=true"
import script from "./tos.vue?vue&type=script&lang=js"
export * from "./tos.vue?vue&type=script&lang=js"

import "./tos.vue?vue&type=style&index=0&id=3c794441&lang=scss&rel=stylesheet%2Fscss&scoped=true"
script.render = render
script.__scopeId = "data-v-3c794441"

export default script